import { csx } from '@vtex/admin-ui'

const styles = {
  noPermissionContainer: csx({
    '& > svg': {
      color: '$secondary',
    },
    '& > :last-child': {
      marginTop: '$space-2',
      textAlign: 'center',
    },
    gap: '$space-2',
    height: 'calc(100vh - 12rem)', // all vertical space minus header height
    padding: '0 $space-12',
  }),
}

export default styles
